<div class="checkbox-container">
  <label class="checkbox">
    <img [src]="getImage()" >
    <input [id]="id" type="checkbox" (change)="onValueChange($event)" (blur)="onTouch()">
  </label>
  <label [for]="id" [innerHtml]="textkey | translate"></label>
</div>
<div *ngIf="invalid" class="errmsg">{{errormessage | translate }}</div>
